<template>
	<div class="auth-main">
		<el-form
			ref="registerForm"
			:model="form"
			:rules="rules"
			label-position="top"
		>
			<el-form-item class="input-item" prop="company_name">
				<el-input
					class="login-input"
					v-model="form.company_name"
					placeholder="请输入企业名称"
					prefix-icon="el-icon-s-custom"
				/>
			</el-form-item>

			<el-form-item class="input-item" prop="mobile">
				<el-input
					class="login-input"
					v-model="form.mobile"
					placeholder="请输入手机号"
					prefix-icon="el-icon-phone"
				/>
			</el-form-item>

			<el-form-item class="input-item" prop="code">
				<el-input
					class="login-input"
					v-model="form.code"
					placeholder="请输入短信验证码"
					prefix-icon="el-icon-message"
				>
					<template slot="append">
						<div>
							<el-button
								class="get-register"
								:disabled="!form.mobile || phoneCode !== '获取验证码'"
								@click="getVerifiCode"
								>{{ phoneCode }}</el-button
							>
						</div>
					</template>
				</el-input>
			</el-form-item>

			<el-form-item class="input-item" style="margin-bottom: 5px !important; ">
				<CaptchaVerify ref="CaptchaVerify" @verify="verifySuccess" />
			</el-form-item>
			<el-form-item class="login-wrapper">
				<CommonButton
					:buttonTitle="'注册并登录'"
					:isDisable="btnLoading"
					class="login-button"
					:type="'primary'"
					@buttonClick="submitRegister"
				/>
			</el-form-item>
			<div class="register-row">
				<span class="register-text">已有账号？</span>
				<el-button type="text" class="login-way register-link" @click="goLogin"
					>立即登录</el-button
				>
			</div>
		</el-form>
	</div>
</template>

<script>
import CommonButton from "@/components/CommonButton";
import CaptchaVerify from "@/components/CaptchaVerify";
import { mapMutations } from "vuex";

export default {
	components: {
		CommonButton,
		CaptchaVerify,
	},
	data() {
		return {
			btnLoading: false,
			captchaPassed: false,
			phoneCode: "获取验证码",
			timer: null,
			form: {
				company_name: "",
				mobile: "",
				code: "",
			},
			rules: {
				company_name: [
					{
						required: true,
						message: "请输入企业名称",
						trigger: ["blur", "change"],
					},
				],
				mobile: [
					{
						required: true,
						message: "请输入手机号",
						trigger: ["blur", "change"],
					},
					{
						min: 11,
						max: 11,
						message: "请输入 11 位手机号",
						trigger: ["blur", "change"],
					},
				],

				code: [
					{
						required: true,
						message: "请输入短信验证码",
						trigger: ["blur", "change"],
					},
				],
			},
		};
	},
	methods: {
		...mapMutations(["handleUserInfo"]),
		countDown(time) {
			if (time === 0) {
				this.phoneCode = "获取验证码";
				return;
			}
			this.phoneCode = `重新发送(${time})`;
			setTimeout(() => this.countDown(time - 1), 1000);
		},
		async getVerifiCode() {
			if (!this.form.mobile) {
				this.$message.error("请先输入手机号");
				return;
			}
			this.$refs.CaptchaVerify.clear();
			this.$refs.CaptchaVerify.popup("code");
		},
		async slideVerify(value) {
			if (value) {
				try {
					let result = await this.$api.getLoginCode({
						mobile: this.form.mobile,
						captchaVerifyParam: this.verify.captchaVerifyParam,
					});
					if (result) {
						this.$message.success("验证码发送成功");
						this.countDown(60);
					}
				} catch (err) {
					console.log(err, "========err");
				}
			}
		},
		verifySuccess(verify) {
			this.verify = verify;
			if (verify.popupId == "code") {
				this.slideVerify(true);
			}
			this.captchaPassed = !!(verify && verify.captchaResult);
		},

		//  账号、密码登录
		async accountLogin(data) {
				try {
					const userInfo = await this.$api.submitLoginInfo({
						account: this.form.mobile,
						password: data.pwd,
						// captchaVerifyParam: this.verify.captchaVerifyParam,
						no_verify: 1
					});
					if (userInfo) {
						this.form = {};
						this.mxInitSwitch();
						this.handleUserInfo(userInfo);
						let obj = {};
						obj.id = userInfo.company_id;
						console.log("赋值两个ID-A");
						this.$storage.set("nowCompany", obj);
						this.$storage.set("settlementId", userInfo.settlement_id);

						const userInfos = await this.$api.getUserProfile();
						this.$storage.set("roles", userInfo.roles);
						this.$storage.set("user_info", userInfos);
						// this.$message.success("登录成功");
						console.log(userInfo, "用户信息2");
						this.mxRedirect("/home");
						console.log(userInfo, "用户信息3");
					} else {
						this.$message.error("登录失败");
						this.initRespErrMsgBoxMark();
						this.$refs.CaptchaVerify.clear();
					}
				} catch (error) {
					this.goLogin();
					this.$refs.CaptchaVerify.clear();
					console.log("login error", error);
				}
		},

		submitRegister() {
			this.$refs["registerForm"].validate(async (valid) => {
				if (!valid) return;
				if (!this.captchaPassed) {
					this.$message.warning("请先完成人机验证");
					return;
				}
				this.btnLoading = true;
				try {
					let result = await this.$api.passportRegister(this.form);
					console.log(result, "========result");
					this.$message.success("注册成功");
					this.btnLoading = false;
					this.accountLogin(result)
					// this.goLogin();
				} catch (err) {
					this.$message.error("提交失败，请稍后重试");
					this.btnLoading = false;
				}
			});
		},
		goLogin() {
			this.$router.push("/loginIndex");
		},
	},
};
</script>

<style lang="scss" scoped>
.auth-main {
	margin: 40px 50px;
}

.input-item {
	margin-bottom: 20px !important;
}

.login-input {
	.el-input__inner {
		height: 42px;
		line-height: 42px;
	}
}

.login-button {
	width: 100%;
	height: 44px;
	margin-top: 10px;
	border: none;
}

.login-button:hover {
	background: #48b4ff;
}

.login-wrapper {
	margin-top: 0;
}

.get-register {
	min-width: 100px;
	color: #1890ff;
	border: none;
	background: transparent;
	padding: 0 6px;
}

.register-row {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-top: 8px;
}

.register-text {
	color: #606266;
	font-size: 14px;
}

.register-link {
	margin-left: 6px;
}
</style>
